import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../../layout/Layout'
import { Form, InputGroup, OverlayTrigger, Table, Tooltip, } from 'react-bootstrap'
import CustomPagination from '../../components/CustomPagination';
import { Link } from 'react-router-dom';
import DeleteModal from '../../components/DeleteModal';
import NoDateFound from '../../components/NoDateFound';
import Loader from '../../components/loader/Loader';
import { useGlobalState } from '../../context/GlobalStateContext';
import axiosInstance from '../../utils/axiosConfig';
import * as CustomToast from '../../components/CustomToastMessage';
import ViewTestimonial from '../../components/testimonial/ViewTestimonial';

function TestimonialList() {
    const [settings, setSettings] = useState([])
    const { loading, setLoading, pagination, setPagination, search, handleSearch, handleLimitChange } = useGlobalState()

    const fetchSettings = useCallback(async (page = 1, limit = 10, searchQuery = '') => {
        try {
            setLoading(true)
            const response = await axiosInstance.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/testimonial/list`, {
                params: {
                    page,
                    limit,
                    search: searchQuery,
                }
            })
            if (response.data.success) {
                setSettings(response.data.data);
                setPagination(response.data.pagination);
            } else {
                setSettings([]);
                setPagination(prev => ({
                    ...prev,
                    currentPage: 1,
                    totalPages: 1,
                    totalItems: 0
                }));
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
            setSettings([]);
            setPagination(prev => ({
                ...prev,
                currentPage: 1,
                totalPages: 1,
                totalItems: 0
            }));
        }
        finally {
            setLoading(false)
        }
    }, [setLoading, setPagination])
    const handleDelete = async (id) => {
        try {
            setLoading(true)
            const response = await axiosInstance.delete(`${process.env.REACT_APP_BACKEND_URL}/api/admin/testimonial/delete/${id}`);
            if (response.data.success) {
                fetchSettings(pagination.currentPage, pagination.limit, search);
                CustomToast.success(response.data.message);
            }
        } catch (error) {
            if (error.response.data.status === 400) {
                CustomToast.error(error.response?.data?.message);
            }
            console.error(error.response?.data?.message || 'Internal server error');
        } finally {
            setLoading(false)
        }
    }
    useEffect(() => {
        fetchSettings(pagination.currentPage, pagination.limit, search);
    }, [pagination.currentPage, pagination.limit, search, fetchSettings])



    return (
        <Layout title="Testimonial List">
            <main>
                <div className="card page-card">
                    <div className="card-header d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                        <div className='d-flex align-items-center gap-3'>
                            <p>Show</p>
                            <Form.Select
                                aria-label="Default select example"
                                value={pagination.limit}
                                onChange={handleLimitChange}
                            >
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                            </Form.Select>
                            <p>entries</p>
                        </div>

                        <div className='d-flex flex-column flex-md-row  align-items-start align-items-md-center gap-3 sm-w-100'>
                            <div className='header-search'>
                                <InputGroup>
                                    <InputGroup.Text id="basic-addon1" className='bg-transparent'>

                                        <img src="/images/png/search.png" width={20} alt="" />
                                    </InputGroup.Text>
                                    <Form.Control
                                        type="search"
                                        className='border-start-0 ps-0'
                                        placeholder="search here..."
                                        value={search}
                                        onChange={handleSearch(fetchSettings)}
                                    />
                                </InputGroup>
                            </div>
                            <Link to="/testimonial/add" className='btn-primary fs-16 fw-600 d-flex justify-content-center align-items-center gap-2 px-3'>
                                <img src="/images/png/plus.png" width={22} alt="" />
                                Add Testimonial
                            </Link>
                        </div>
                    </div>
                    <div className="card-body">
                        <div className="overflow-auto">
                            <Table>
                                <thead>
                                    <tr>
                                        <th width="40">Id</th>
                                        <th>Username</th>
                                        <th>Description</th>
                                        <th>Created Date</th>
                                        <th width="100" className='text-center'>Action</th>
                                    </tr>
                                </thead>
                                <tbody>{loading ?
                                    (<tr>
                                        <td colSpan="7" className="text-center">
                                            <Loader />
                                        </td>
                                    </tr>)
                                    : settings.length > 0 ? (
                                        settings.map((item, index) => (
                                            <tr key={item._id}>
                                                <td width="40">
                                                    <p className='mb-0'>{(pagination.currentPage - 1) * pagination.limit + index + 1}</p>
                                                </td>
                                                <td className='table-td-200'>
                                                    <p className='mb-0'>{item.userName ? item.userName : "-"}</p></td>
                                                <td className='table-td-200'>
                                                    <p className='mb-0 table-td-500 limit-lines' dangerouslySetInnerHTML={{ __html: item.description ? item.description : "" }} />
                                                </td>
                                                <td className='table-td-150'>{item.createdAt ? new Date(item.createdAt).toISOString().split('T')[0] : "-"}</td>
                                                <td>
                                                    <div className='d-flex align-items-center gap-2'>
                                                        <ViewTestimonial setting={item} />
                                                        <OverlayTrigger
                                                            key="top"
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id="tooltip-top">
                                                                    Edit
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <Link to={`/testimonial/edit/${item._id}`}>
                                                                <img src="/images/png/edit.png" className="pointer" width={35} alt="action" />
                                                            </Link>
                                                        </OverlayTrigger>
                                                        <DeleteModal
                                                            onConfirm={() => handleDelete(item._id)}
                                                            loading={loading}
                                                            flag={"testimonial"}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10" className="text-center">
                                                <NoDateFound />
                                            </td>
                                        </tr>
                                    )}

                                </tbody>
                            </Table>
                        </div>
                        <CustomPagination
                            currentPage={pagination.currentPage}
                            totalPages={pagination.totalPages}
                            totalItems={pagination.totalItems}
                            limit={pagination.limit}
                            onPageChange={(page) => setPagination(prev => ({ ...prev, currentPage: page }))}
                        />
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default TestimonialList